<template>
  <v-app id="inspire">
    <eps-sidebar></eps-sidebar>
      <eps-header :drawer="$store.state.drawer"></eps-header>

    <v-content>  
      <v-container fluid>
         <router-view>
           
         </router-view>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import mgmtSidebar from "./Sidebar";
import epsHeader from "./Header"; 
export default {
  data: () => ({
    
  }),
  components: {
    'eps-sidebar': mgmtSidebar,
     'epsHeader': epsHeader,
  },
 
};
</script>


<style scoped>
</style>